export const PROPERTY_VALUE_RATIO = 1.7 // Коэффициент стоимости недвижимости
export const DEFAULT_PERCENT = 1 // 1% /мес
export const DEFAULT_PERCENT_YEAR = 9.5 // /год
export const DEFAULT_LOAN_SUM = 1000000 // 1 млн
export const DEFAULT_PERIOD = 12 * 10 // 10 лет

export const DEFAULT_NEW_LOAN_SUM = 1.3e6 // 100 тыс
export const DEFAULT_NEW_PERIOD_YEAR = 10 // 10 лет
